import React from 'react'
import { observer } from 'mobx-react'
import { autobind } from 'core-decorators'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { IoIosRefresh } from 'react-icons/io'

import ContentLoadingBox from '../../shared/components/ContentLoadingBox'
import GenevaWrapper from '../../shared/custom/geneva-wrapper'
import { IUserResponse } from '../../models'
import { IApplicationStore } from '../../stores'

const backgroundImage = require('../../static/background.svg')

require('./Login.scss')

interface ILoginProps {
  applicationStore: IApplicationStore,
  handleUpdateLoggedIn: Function,
  invalidURL: boolean,
  errorType: string
}

interface IState {
  error: number,
  inputPassword: string,
  isLoading: boolean,
  errorType: string
}

@observer
export default class Login extends React.Component<ILoginProps> {
  state: IState
  loginMessage: string

  constructor(props: ILoginProps) {
    super(props)
    this.loginMessage = ''
    this.state = {
      error: props.invalidURL ? 1 : 0,
      inputPassword: '',
      isLoading: false,
      errorType: props.errorType
    }
  }

  componentWillReceiveProps(nextProps: ILoginProps) {
    if (nextProps.invalidURL) {
      this.setState({
        error: nextProps.invalidURL ? 1 : 0,
        errorType: nextProps.errorType ? nextProps.errorType : '1'
      })
    }
  }

  componentWillUnmount() {
    document.body.style.background = 'initial'
  }

  @autobind
  updateInputPasswordValue(evt) {
    this.setState({
      inputPassword: evt.target.value
    })
  }

  @autobind
  handleInputPasswordKeyPress(evt) {
    if (evt.key === 'Enter') {
      this.submitLogin()
    }
  }

  @autobind
  submitLogin() {
    this.setState({
      isLoading: true
    })
    
    GenevaWrapper.post(
      'review/login',
      {
        password: this.state.inputPassword,
        token: this.props.applicationStore.token
      },
      {
        successCallback: (body: IUserResponse) => {
          
          this.setState({
            isLoading: false
          })
          if (body.data) {
            this.props.applicationStore.token = body.data.token
            this.props.applicationStore.setLanguage(body.data.guiIso)
            this.props.handleUpdateLoggedIn(true)
            this.props.applicationStore.setRoom()
          }
        },
        errorCallback: (res: any) => {
          this.setState({
            isLoading: false
          })
          this.setState({
            error: 1,
            errorType: res && res.status_code ? res.status_code.toString() : 'other'
          })
          console.warn(res)
        }

      }
    )
  }

  renderLoader() {
    return (
      <ContentLoadingBox
        spinner
      />
    )
  }

  renderBody() {
    const { loggedInStatus } = this.props.applicationStore

    const incomplete = this.state.inputPassword === ''


    if (loggedInStatus === 'unknown') {
      return this.renderLoader()
    }
    if (this.props.applicationStore.userName === 'Unknown') {
      return (
        <div className="login-body url-error">
          <p>
            <FormattedMessage id="login.url-error.part1" />
          </p>
          <p>
            <FormattedMessage id="login.url-error.part2" />
          </p>
        </div>)
    }
    return (
      <div className="login-body">
        <p className="welcome">
          <FormattedMessage
            id="login.greeting"
            values={{
              user: this.props.applicationStore.userName
            }}
          />
        </p>
        <div className="form-group password">
          <label htmlFor="password">
            <FormattedMessage
              id="login.password"
              tagName="span"
            />
          </label>
          <input
            autoFocus
            type="password"
            name="password"
            className="form-control"
            id="password"
            value={this.state.inputPassword}
            onChange={this.updateInputPasswordValue}
            onKeyPress={this.handleInputPasswordKeyPress}
            disabled={this.props.invalidURL}
          />
          <button className="btn btn-primary"
            onClick={this.submitLogin}
            disabled={this.state.isLoading || incomplete}
          >
            {
              this.state.isLoading
                ? <IoIosRefresh
                  size={18}
                />
                : <FormattedMessage
                  id="login.ok"
                  tagName="span"
                  defaultMessage="OK"
                />
            }
          </button>
        </div>
        <div className={classNames('text-danger status', { hidden: !this.state.error })}>
          <hr />
          <FormattedMessage
            defaultMessage="Anmeldung Error"
            id={`login.error-${this.state.errorType}`}
            tagName="span"
          />
        </div>
      </div>
    )
  }

  render() {


    document.body.style.backgroundImage = `url(${backgroundImage})`
    document.body.style.backgroundRepeat = 'no-repeat'
    document.body.style.backgroundSize = 'cover'
    document.body.style.backgroundPosition = 'bottom center'

    return (
      <div className="login">
        <div id="startscreen" className="start">
          <div className="login-dialog-wrapper">
            <div className="login-dialog">
              <div className="login-header">
                <div className="logo">
                  GENEVA
                </div>
              </div>
              {this.renderBody()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
